import React, { Component } from 'react';
import StepButtons from '../../StepButtons';
import styled from 'styled-components';
import SelectedButton from '../../SelectedButton';
import PrimaryText from '../PrimaryText';
import { LANDSCAPES } from 'constants/index';
import { Formik } from 'formik';

const TravelingForBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const TravelingForPrimaryBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 70%;
  min-height: 500px;
  justify-content: center;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const Content = styled.div`
  display: flex;
  width: 95%;
  flex-wrap: wrap;
  justify-content: center;
`;

const Container = styled.div`
  height: 90%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

class RainingLevelView extends Component {
  render() {
    const { step, state, changeStep, landscapes } = this.props;

    return (
      <TravelingForBox>
        <TravelingForPrimaryBox>
          <PrimaryText text="Which of the following landscapes would you enjoy experiencing on your upcoming journey?" />

          <Formik enableReinitialize initialValues={{ landscapes }} isInitialValid={true}>
            {({ values, handleChange, errors, handleSubmit, setFieldValue }) => {
              const changeLandscapes = value => {
                const landscapes = [...values.landscapes];
                const exist = landscapes.indexOf(value);
                if (exist != -1) {
                  landscapes.splice(exist, 1);
                } else {
                  landscapes.push(value);
                }
                setFieldValue('landscapes', landscapes);
              };
              return (
                <Container>
                  <Content>
                    {LANDSCAPES.map(landscape => (
                      <SelectedButton
                        text={landscape}
                        onClick={() => changeLandscapes(landscape)}
                        active={values.landscapes.includes(landscape)}
                      />
                    ))}
                  </Content>

                  <StepButtons
                    nextDisabled={!values.landscapes.length}
                    backStep={() => changeStep(step - 1, values)}
                    nextStep={() => changeStep(step + 1, values)}
                  />
                </Container>
              );
            }}
          </Formik>
        </TravelingForPrimaryBox>
      </TravelingForBox>
    );
  }
}

export default RainingLevelView;
